export default function () {
  return {
    invoices: [],
    invoice: {},
    invoiceLines: [],
    invoiceDeletedItems: [],
    invoiceAccountEntries: [],
    workingInvoice: [],
    payments: []
  }
}
